import React from "react";
import SvgIcon from "../../../../parts/SvgIcon";

function ExerciseVideoLine({
  vidItem,
  exerciseToEdit,
  indexIndividualSet,
  setIndex,
  src = "/img/new-icons/play-white.svg",
}) {
  return (
    <a
      href={`/actions/refresh?modal[type]=exercise-set-video&mediaId=${vidItem.videoId}&originalId=${vidItem.videoOriginal}&reviewedByTheCoach=${vidItem.reviewedByTheCoach}&exerciseToEdit=${exerciseToEdit}&setIndex=${setIndex}&videoIndex=${indexIndividualSet}&uploaderId=${vidItem.uploaderId}`}
    >
      <SvgIcon
        className="play-icon"
        src={src}
        alt="Play video"
        noFilterOnLight={true}
      />
    </a>
  );
}

export default ExerciseVideoLine;
